import { FC } from "react"
import { MainLayout } from "./MainLayout"

export const DashboardPage: FC = () => {
  return <MainLayout>dashboard page</MainLayout>
}
